import { AbsCheckBox, Button, BUTTONS, Modal } from "abs-ui-components";
import CloseIcon from "@mui/icons-material/Close";
import "./ResultSummaryModal.scss"
import { useMemo } from "react";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";

const ResultSummaryModal = ({
    isOpen,
    onClose,
    headerTitle,
    subHeaderTitle,
    resultSummaryData = [],
    successMsg
}) => {

    const columns = useMemo(
        () => [
            {
                header: "IMO Number", accessorKey: "vesselImoNumber", enableSorting: false,
                enableColumnActions: false,
                enableColumnFilters: false,
                size: 100
            },
            {
                header: "Vessel Name", accessorKey: "vesselName", enableSorting: false,
                enableColumnActions: false,
                enableColumnFilters: false,
                size: 120
            },
            {
                header: "Submitter WCN", accessorKey: "submitterWCN", enableSorting: false,
                enableColumnActions: false,
                enableColumnFilters: false,
                size: 100
            },
            {
                header: "Company Name", accessorKey: "companyName", enableSorting: false,
                enableColumnActions: false,
                enableColumnFilters: false,
                size: 180
            },
            {
                header: "Details", accessorKey: "isCloned", enableSorting: false,
                enableColumnActions: false,
                enableColumnFilters: false,
                Cell: ({ row }) => (
                    <div>
                        {row.original.isCloned ? (
                            <span style={{ color: "green", padding: "6px", border: "1px solid green", borderRadius: "8px" }}>{successMsg} cloned successfully</span>
                        ) : (<span style={{ color: "red", padding: "6px", border: "1px solid red", borderRadius: "8px" }}>Clone failed</span>
                        )}
                    </div>
                ),
                size: 200
            },
        ],
        []
    );


    const table = useMaterialReactTable({
        columns,
        data: resultSummaryData || [],
        enableStickyHeader: true,
        enableSorting: false,
        enableColumnFilters: false,
        enableTopToolbar: false,
        enableBottomToolbar: false,
        enablePagination: false,
        muiTableHeadCellProps: {
            sx: {
                backgroundColor: "#042a4c",
                fontWeight: "bold",
                color: "#ffffff",
                fontSize: "12px",
                paddingY: "3px",
            },
        },

        muiTableBodyRowProps: {
            sx: { height: "45px" },
        },
        muiTableContainerProps: {
            sx: {
                maxHeight: "350px",
                overflowY: "auto",
            },
        },
        muiTableBodyCellProps: {
            sx: {
                paddingY: "2px",
                paddingX: "6px",
                fontSize: "12px",
                lineHeight: "1.2",
            },
        },
    });

    return (
        <Modal
            isOpen={isOpen}
            padding="0"
            showFooter
            onCloseClickListener={onClose}
            footer={
                <div className="d-flex justify-content-between align-items-center mx-3 pt-0 mb-2 pl-1 footer-clone-border">
                    <div className="text-muted mt-2">
                        <p className="result-footer-clone-text">Resolve the failed items and retry the clone if required.</p>
                    </div>
                    <div className="d-flex justify-content-end p-1">
                        <Button
                            className="ms-2 ml-3 modal-footer-btn"
                            onClick={onClose}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            }
        >
            <div
                className="clone-modal-header"
                style={{
                    backgroundColor: "#00395D",
                    color: "white",
                    padding: "6px 20px",
                    fontSize: "18px",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                    marginTop: "-1rem",
                }}
            >
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>{headerTitle}</span>
                    {subHeaderTitle && (
                        <span
                            style={{
                                fontSize: "14px",
                                fontWeight: "400",
                                opacity: 0.9,
                                marginTop: "1px"
                            }}
                        >
                            {subHeaderTitle}
                        </span>
                    )}
                </div>

                <CloseIcon
                    onClick={onClose}
                    style={{
                        cursor: "pointer",
                        color: "white",
                        border: "1px solid rgba(255, 255, 255, 0.6)",
                        borderRadius: "50%",
                        padding: "4px",
                        boxSizing: "border-box",
                    }}
                />
            </div>
            <div className="clone-modal" style={{ padding: "20px" }}>
                <p className="mb-2 text-muted" style={{ fontSize: "14px" }}>Below is the list of vessels with the outcome of the {successMsg} clone action</p>
                <MaterialReactTable table={table} />
            </div>
        </Modal>

    );
}

export default ResultSummaryModal;